export default {"src":"/_next/static/media/purple-left.24d64d29.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};